module.exports = __webpack_public_path__ + "img/repcom_app.16394d02.svg";